module.exports = __webpack_public_path__ + "static/media/qr_code.1d9b54e6.jpg";